// extracted by mini-css-extract-plugin
var _1 = "u2iKTmxQhUFyTWLo28kD";
export { _1 as "maxHeightModal" }
